/* eslint-disable eqeqeq */

import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getIsDesktop } from '../../../utils/Utils';
import arrow_left from '../../../img/experts/arrow_left.svg';
import arrow_right from '../../../img/experts/arrow_right.svg';

// const slides = [
//   { title: 'Занятия онлайн', description: 'На данной платформе — только онлайн-занятия. Это очень удобно, ведь вам не нужно тратить время на дорогу, и вы можете выбрать лучшего репетитора, не ограничиваясь вашим местоположением.', icon : advantages_world_pays},
//   { title: 'Слайд 2', description: 'Описание слайда 2' },
//   { title: 'Слайд 3', description: 'Описание слайда 3' },
//   { title: 'Слайд 4', description: 'Описание слайда 4' },
//   { title: 'Слайд 5', description: 'Описание слайда 5' },
// ];

const AdvantagesSlider = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const advantages = props.advantages
  const pickedAdvantage = props.pickedAdvantage
  const handleSlideSwipe = (direction) => {
    const newIndex = currentIndex + direction;
    if (newIndex >= 0 && newIndex < advantages.length) {
      setCurrentIndex(newIndex);
    }
  };
  useEffect(() => {
    if (pickedAdvantage != undefined) {
       const foundIndex = advantages.findIndex((obj => obj.icon == pickedAdvantage.icon))
       console.log("advantages = ", advantages)
       console.log("pickedAdvantage = ", pickedAdvantage)
       console.log("foundIndex = ", foundIndex)
       if (foundIndex != -1){
        setCurrentIndex(foundIndex)
       }
       
    }
  }, [pickedAdvantage])
  const isDesktop = getIsDesktop()
  const sliderStyles = {
    container: {
      position: 'relative',
      width: isDesktop ? '100%' : '360px',
      height: '240px',
      overflow: 'hidden',
      padding: '0 8px'
    },
    slidesWrapper: {
      display: 'flex',
      height: '100%',
    },
    slide: {
      minWidth: isDesktop ? '328px' : '100%',
      //   padding: '20px',
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '12px',
      maxWidth: isDesktop ? '312px' : 'calc(100vw - 48px)'
    },
    description: {
      fontSize: '16px',
      color: '#666',
      maxWidth: isDesktop ? '312px' : 'calc(100vw - 48px)'
    },
    indicators: {
      position: 'absolute',
      bottom: '8px',
      left: '8px',
      display: 'flex',
      justifyContent: 'left',
      gap: '6px',
    },
    indicator: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#ccc',
    },
    activeIndicator: {
      backgroundColor: 'black',
    },
  };
  const onLeft = () => {
    handleSlideSwipe(-1)
  }
  const onRight = () => {
    handleSlideSwipe(1)
  }
  return (
    <div>
      {currentIndex != 0 && <img onClick={onLeft} alt='arrow_left' className='arrow_left_advantages hover' src={arrow_left}/>}
      {currentIndex < (advantages.length - 1) && <img onClick={onRight} alt='arrow_right' className='arrow_right_advantages hover' src={arrow_right}/>}
      <div className='relative' style={sliderStyles.container}>
        <motion.div
          style={sliderStyles.slidesWrapper}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          onDragEnd={(_, info) => {
            if (Math.abs(info.offset.x) > 100) {
              handleSlideSwipe(info.offset.x > 0 ? -1 : 1);
            }
          }}
        >
          <div style={sliderStyles.slidesWrapper}>
            {advantages.map((slide, index) => (
              <motion.div
                key={index}
                style={sliderStyles.slide}
                initial={{ x: index === currentIndex ? 0 : index > currentIndex ? 100 : -100 }}
                animate={{ x: -100 * currentIndex + '%' }}
                transition={{ duration: 0.3 }}
              >
                <h2 className='experts_advantages_slider_t' style={sliderStyles.title}>{slide.title}</h2>
                <p className='experts_advantages_slider_d' style={sliderStyles.description}>{slide.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <div style={sliderStyles.indicators}>
          {advantages.map((_, index) => (
            <div
              key={index}
              style={{
                ...sliderStyles.indicator,
                ...(index === currentIndex ? sliderStyles.activeIndicator : {}),
              }}
            />
          ))}
        </div>
        <img alt='icon' className='experts_advantages_slider_img' src={advantages[currentIndex].icon} />
      </div>
    </div>
  );
};

export default AdvantagesSlider;